<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Variable" class="d-icon d-icon--variable" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M2 9.5V7a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1A.5.5 0 0 0 2 5V2.5A1.5 1.5 0 0 1 3.5 1H4a.5.5 0 0 1 0 1h-.5a.5.5 0 0 0-.5.5V5c0 .37-.14.725-.386 1 .247.275.386.63.386 1v2.5c0 .274.226.5.5.5H4a.5.5 0 0 1 0 1h-.5C2.674 11 2 10.326 2 9.5Zm7 0V7c0-.384.146-.734.385-1A1.498 1.498 0 0 1 9 5V2.5a.5.5 0 0 0-.5-.5H8a.5.5 0 0 1 0-1h.5A1.5 1.5 0 0 1 10 2.5V5a.5.5 0 0 0 .5.5.5.5 0 0 1 .1.99l-.2.02A.504.504 0 0 0 10 7v2.5A1.5 1.5 0 0 1 8.5 11H8a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .5-.5ZM6.896 4.396a.5.5 0 1 1 .708.708L6.707 6l.897.896a.5.5 0 1 1-.708.708L6 6.707l-.896.897a.5.5 0 1 1-.708-.708L5.293 6l-.897-.896a.5.5 0 1 1 .708-.708L6 5.293l.896-.897Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconVariable',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
